import { render, staticRenderFns } from "./AddRoom.vue?vue&type=template&id=5e473f10&scoped=true&"
import script from "./AddRoom.vue?vue&type=script&lang=js&"
export * from "./AddRoom.vue?vue&type=script&lang=js&"
import style0 from "./AddRoom.vue?vue&type=style&index=0&id=5e473f10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e473f10",
  null
  
)

export default component.exports